"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[192],{

/***/ 37171:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ v1_SitewideWarning; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/core/Modal/Modal.jsx + 1 modules
var Modal = __webpack_require__(78145);
// EXTERNAL MODULE: ./components/core/Button/Button.jsx + 1 modules
var Button = __webpack_require__(7872);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(24400);
// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
;// CONCATENATED MODULE: ./components/SitewideWarning/analytics.js


const siteWideWarningModalCloseEventInfo = (param)=>{
    let { eventPageType ="" , internalLinkName ="" , internalLinkURL ="n/a" , returnString =false , clickInternalLinks ="false"  } = param;
    var ref, ref1, ref2, ref3;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const content = page === null || page === void 0 ? void 0 : (ref = page.pageInfo) === null || ref === void 0 ? void 0 : ref.contentType;
    const pageInfoDetails = window === null || window === void 0 ? void 0 : (ref1 = window.adobeDataLayer) === null || ref1 === void 0 ? void 0 : ref1.getState("page");
    const { productInfo  } = page;
    const experienceName = content === "locations" ? "locations:kohler stores" : eventPageType || (window === null || window === void 0 ? void 0 : window.eventPageType);
    const eventName = "".concat(experienceName, ":share:").concat(internalLinkName);
    let internalLinkpositionName = "".concat(experienceName, ":social share pop up");
    if ((pageInfoDetails === null || pageInfoDetails === void 0 ? void 0 : (ref2 = pageInfoDetails.pageInfo) === null || ref2 === void 0 ? void 0 : ref2.contentType) && (pageInfoDetails === null || pageInfoDetails === void 0 ? void 0 : (ref3 = pageInfoDetails.pageInfo) === null || ref3 === void 0 ? void 0 : ref3.contentType) === "pdp" && !isEmpty_default()(productInfo)) {
        if (productInfo.pdpType === "bundle") {
            internalLinkpositionName = "pdp:social share pop up:bundle";
        }
    }
    const eventInfo = {
        clickInternalLinks,
        eventAction: eventName,
        eventMsg: "n/a",
        eventName,
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName,
        internalLinkPosition: internalLinkpositionName,
        internalLinkType: "".concat(experienceName, ":navigation"),
        internalLinkURL,
        internalLinkZoneName: "".concat(experienceName, ":social share")
    };
    if (returnString) {
        return JSON.stringify(eventInfo);
    }
    return eventInfo;
};
const siteWideWarningModalCloseAnalytics = (eventInfo)=>{
    (0,helper.pushAnalyticsObjToDataLayer)(eventInfo);
};

;// CONCATENATED MODULE: ./components/SitewideWarning/v1/SitewideWarning.jsx









const SitewideWarning = (props)=>{
    const { enableSiteWideWarning  } = (0,es/* useSelector */.v9)(genericSlice.selectGenericState);
    const { siteWideWarning  } = props;
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const [showModal, setShowModal] = (0,react.useState)(false);
    const [componentProps, setComponentProps] = (0,react.useState)({});
    const [dataLayer, setDataLayer] = (0,react.useState)();
    const isSocialShare = ()=>{
        var ref;
        return (window === null || window === void 0 ? void 0 : (ref = window.sitewideWarningEvent) === null || ref === void 0 ? void 0 : ref.linkType) === "social media";
    };
    /**
   *
   * @param {*} shouldRedirect Boolean
   * Handle the redirect if the user select yes from the model
   */ const handleRedirect = (shouldRedirect)=>{
        const e = window.sitewideWarningEvent;
        if (e && shouldRedirect) {
            if (e.target.target === "_blank" || e.target === "_blank") {
                var _href;
                window.open((_href = e.target.href) !== null && _href !== void 0 ? _href : e.href);
            } else {
                var _href1;
                window.location = (_href1 = e.target.href) !== null && _href1 !== void 0 ? _href1 : e.href;
            }
        }
        if (isSocialShare()) {
            var ref;
            const eventInfo = siteWideWarningModalCloseEventInfo({
                internalLinkName: (ref = shouldRedirect ? t("kf.label.sitewide.warning.yesCta") : t("kf.label.sitewide.warning.noCta")) === null || ref === void 0 ? void 0 : ref.toLowerCase(),
                internalLinkURL: shouldRedirect ? e.target.href || e.href : "n/a",
                clickInternalLinks: shouldRedirect ? "false" : "true"
            });
            siteWideWarningModalCloseAnalytics(eventInfo);
        }
        window.showSiteWideWarning(false);
        window.sitewideWarningEvent = null;
    };
    /**
   *
   * @param {*} url String (  the url to be added to the model)
   * @param {*} target String (  the target)
   * This will handle the model content and map the url to be redirected based on user selection
   *
   */ const handleShowModal = (url, target)=>{
        var ref;
        const e = {
            target: "_blank",
            href: url,
            linkType: (ref = target === null || target === void 0 ? void 0 : target.getAttribute("data-link-type")) !== null && ref !== void 0 ? ref : ""
        };
        window.sitewideWarningEvent = e;
        window.showSiteWideWarning(true);
    };
    (0,react.useEffect)(()=>{
        window.showSiteWideWarning = setShowModal;
        const authorData = siteWideWarning ? siteWideWarning : {};
        const excludUrl = (authorData === null || authorData === void 0 ? void 0 : authorData.popupIgnoreUrls) ? authorData === null || authorData === void 0 ? void 0 : authorData.popupIgnoreUrls.map((item)=>item.url).toString() : "";
        document.querySelectorAll('a[href^="http"]:not([data-siteWideWarning-added="true"])').forEach((link)=>{
            const nodeListUrl = link.hostname.replace(/(^www\.)/, "");
            link.setAttribute("data-siteWideWarning-added", true);
            if (!excludUrl.includes(nodeListUrl)) {
                link.onclick = function(e) {
                    var ref, ref1, ref2;
                    e.stopPropagation();
                    e.preventDefault();
                    triggerAnalyticsPart(this);
                    var ref3;
                    const event = {
                        target: (ref = this) === null || ref === void 0 ? void 0 : ref.target,
                        href: (ref1 = this) === null || ref1 === void 0 ? void 0 : ref1.href,
                        linkType: (ref3 = (ref2 = this) === null || ref2 === void 0 ? void 0 : ref2.getAttribute("data-link-type")) !== null && ref3 !== void 0 ? ref3 : ""
                    };
                    window.sitewideWarningEvent = event;
                    window.showSiteWideWarning(true);
                };
            }
        });
        document.querySelectorAll('a[data-gbh-data-layer]:not([href^="http"]):not(.gbh-data-layer):not([data-gbh-clickable=true])').forEach((link)=>{
            link.onclick = function(e) {
                triggerAnalyticsPart(this);
            };
        });
        const triggerAnalyticsPart = (obj)=>{
            let gbhDataLayer = obj.getAttribute("data-gbh-data-layer");
            const gbhDataLayerCustom = obj.getAttribute("data-gbh-data-layer-custom");
            const gbhDataLayerCustomParse = JSON.parse(gbhDataLayerCustom);
            const productInfo = gbhDataLayerCustomParse && gbhDataLayerCustomParse.productInfo ? gbhDataLayerCustomParse.productInfo : undefined;
            if (!gbhDataLayer) {
                var ref;
                const pageInfoDetails = window === null || window === void 0 ? void 0 : (ref = window.adobeDataLayer) === null || ref === void 0 ? void 0 : ref.getState("page");
                const parentDiv = obj.closest(".cmp-teaser__description");
                if (parentDiv) {
                    var ref1, ref2;
                    gbhDataLayer = parentDiv.getAttribute("data-gbh-data-layer");
                    const teaserDescriptionJson = JSON.parse(gbhDataLayer);
                    const eventActionMessage = teaserDescriptionJson.eventAction.split(":");
                    if ((pageInfoDetails === null || pageInfoDetails === void 0 ? void 0 : (ref1 = pageInfoDetails.pageInfo) === null || ref1 === void 0 ? void 0 : ref1.contentType) && (pageInfoDetails === null || pageInfoDetails === void 0 ? void 0 : (ref2 = pageInfoDetails.pageInfo) === null || ref2 === void 0 ? void 0 : ref2.contentType) === "pdp") {
                        var ref3, ref4, ref5, ref6;
                        const isPdpEvent = "".concat(pageInfoDetails === null || pageInfoDetails === void 0 ? void 0 : (ref3 = pageInfoDetails.pageInfo) === null || ref3 === void 0 ? void 0 : ref3.contentType, ":").concat(eventActionMessage[1], ":").concat(obj === null || obj === void 0 ? void 0 : (ref4 = obj.innerText) === null || ref4 === void 0 ? void 0 : ref4.toLowerCase());
                        teaserDescriptionJson.eventAction = isPdpEvent;
                        teaserDescriptionJson.eventName = isPdpEvent;
                        teaserDescriptionJson.eventType = "navigation";
                        teaserDescriptionJson.internalLinkName = obj === null || obj === void 0 ? void 0 : (ref5 = obj.innerText) === null || ref5 === void 0 ? void 0 : ref5.toLowerCase();
                        teaserDescriptionJson.internalLinkPosition = "pdp";
                        teaserDescriptionJson.internalLinkName = obj === null || obj === void 0 ? void 0 : (ref6 = obj.innerText) === null || ref6 === void 0 ? void 0 : ref6.toLowerCase();
                        teaserDescriptionJson.internalLinkZoneName = "pdp:teaser";
                        teaserDescriptionJson.internalLinkZoneName = "pdp:".concat(eventActionMessage[1]);
                    }
                    teaserDescriptionJson.internalLinkURL = obj === null || obj === void 0 ? void 0 : obj.href;
                    const targetAnchorTag = obj.getAttribute("target");
                    if (targetAnchorTag === "_blank") {
                        teaserDescriptionJson.clickInternalLinks = "false";
                    }
                    gbhDataLayer = JSON.stringify(teaserDescriptionJson);
                }
            }
            if (gbhDataLayer) {
                setDataLayer(gbhDataLayer);
                const { adobeDataLayer: { getState  } = {}  } = window;
                const page = (window === null || window === void 0 ? void 0 : window.pageObj) || getState && getState("page") || {};
                const regex = new RegExp("(<([^>]+)>)", "ig");
                const jsonString = gbhDataLayer.replaceAll(regex, "").replaceAll(/(\r\n|\n|\r)/gm, "");
                if (!obj.getAttribute("data-gbh-clickable")) {
                    window.adobeDataLayer.push({
                        event: "cmp:click",
                        eventInfo: JSON.parse(jsonString),
                        page,
                        ...productInfo ? {
                            productInfo
                        } : {}
                    });
                }
            }
        };
        /**
     * Populating the popup valur to be shown in the page
     */ const popupVal = {
            title: authorData && authorData.popupMessageTitle ? authorData.popupMessageTitle : t("kf.label.sitewide.warning.modalWindow"),
            description: authorData && authorData.popupMessage ? authorData.popupMessage : t("kf.label.sitewide.warning.desc")
        };
        setComponentProps(popupVal);
        window.handleShowModal = handleShowModal;
        window.excludUrl = excludUrl;
        window.showSiteWideWarningRendered = true;
    }, [
        enableSiteWideWarning
    ]);
    (0,react.useEffect)(()=>{
        if (showModal) {
            (0,helper.preventBodyScroll)(true);
        }
        return ()=>{
            (0,helper.preventBodyScroll)(false);
        };
    }, [
        showModal
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal["default"], {
        className: "site-warning-part-diagram",
        showModal: showModal,
        onModalClose: ()=>{
            (0,helper.addMavenoidChat)();
            window.showSiteWideWarning(false);
        },
        needAnalyticsOnContentsLink: true,
        dataLayer: dataLayer,
        modalTitle: componentProps.title,
        ...isSocialShare() ? {
            closeButtonAnalytics: siteWideWarningModalCloseEventInfo({
                internalLinkName: "close",
                internalLinkURL: "n/a",
                returnString: true,
                clickInternalLinks: "true"
            })
        } : {},
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "sitewide-warning",
            "aria-labelledby": "sitewide-warning__title",
            "aria-describedby": "sitewide-warning__desc",
            "data-testid": "sitewidewarning-model",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: "sitewide-warning__title",
                    id: "sitewide-warning__title",
                    children: componentProps.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "sitewide-warning__desc",
                    id: "sitewide-warning__desc",
                    children: (0,helper.sanitizeInnerHtml)(componentProps.description)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                    role: "button",
                    onClick: ()=>handleRedirect(true),
                    label: t("kf.label.sitewide.warning.yesCta"),
                    flexible: true,
                    useDefaultClass: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                    role: "button",
                    onClick: ()=>handleRedirect(false),
                    label: t("kf.label.sitewide.warning.noCta"),
                    type: "ghost",
                    flexible: true
                })
            ]
        })
    });
};
/* harmony default export */ var v1_SitewideWarning = (SitewideWarning);


/***/ })

}]);